export const splunkRUM = {
  SPLUNK_RUM_AUTH: '0wLtiDnXf51Urp2izn_AJA',
  SPLUNK_BEACON_URL: 'https://rum-ingest.us1.signalfx.com/v1/rum',
  SPLUNK_APP_NAME: 'Payments',
};
